import { api } from '@/services/api';
import type {
  Consumidor,
  ConsumidorCreate,
  ConsumidorCriado,
  ConsumidorUpdate,
  ConsumidorUso,
} from '@/types/consumidores';

const BASE = '/config/consumidores';

export const consumidoresApi = {
  list: () => api.get<Consumidor[]>(BASE),
  create: (payload: ConsumidorCreate) => api.post<ConsumidorCriado>(BASE, payload),
  update: (id: string, payload: ConsumidorUpdate) =>
    api.patch<Consumidor>(`${BASE}/${id}`, payload),
  revoke: (id: string) => api.post<Consumidor>(`${BASE}/${id}/revogar`),
  usage: (id: string) => api.get<ConsumidorUso>(`${BASE}/${id}/uso`),
};
